<template>
  <nav class="navbar navbar-expand navbar-light bg-white static-top madgui-nav sticky-top">
    &nbsp;&nbsp;
    <button
      id="sidebarToggle"
      class="btn btn-link btn-sm text-secondary order-1 order-sm-0"
      @click="toggleSidebar"
    >
      <i class="fas fa-bars" />
    </button> &nbsp;&nbsp;

    <Brand />

    <!-- Navbar Search -->
    <form
      v-if="options.topNav.show.search"
      class="d-none d-md-inline-block form-inline ml-auto mr-0 mr-md-5 my-2 my-md-0 madgui-navbar-search"
    >
      <VideoTags />
      <!-- <VideoSearch /> -->
    </form>
    <!-- Navbar -->

    <ul class="navbar-nav ml-auto ml-md-0 madgui-right-navbar">
      <li
        v-if="options.topNav.show.uploadVideo"
        class="nav-item mx-1"
      >
        <RouterLink
          class="nav-link"
          to="/upload"
        >
          <i class="fas fa-plus-circle fa-fw" />
          Upload Video
        </RouterLink>
      </li>
      <li
        v-if="options.topNav.show.notifications"
        class="nav-item dropdown no-arrow mx-1"
      >
        <a
          id="alertsDropdown"
          class="nav-link dropdown-toggle"
          href="#"
          role="button"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
        >
          <i class="fas fa-bell fa-fw" />
          <span class="badge badge-danger">
            9+
          </span>
        </a>
        <div
          class="dropdown-menu dropdown-menu-right"
          aria-labelledby="alertsDropdown"
        >
          <a
            class="dropdown-item"
            href="#"
          >
            <i class="fas fa-fw fa-edit " /> &nbsp; Action
          </a>
          <a
            class="dropdown-item"
            href="#"
          >
            <i class="fas fa-fw fa-headphones-alt " /> &nbsp; Another action
          </a>
          <div class="dropdown-divider" />
          <a
            class="dropdown-item"
            href="#"
          >
            <i class="fas fa-fw fa-star " /> &nbsp; Something else here
          </a>
        </div>
      </li>
      <li
        v-if="options.topNav.show.messages"
        class="nav-item dropdown no-arrow mx-1"
      >
        <a
          id="messagesDropdown"
          class="nav-link dropdown-toggle"
          href="#"
          role="button"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
        >
          <i class="fas fa-envelope fa-fw" />
          <span class="badge badge-success">
            7
          </span>
        </a>
        <div
          class="dropdown-menu dropdown-menu-right"
          aria-labelledby="messagesDropdown"
        >
          <a
            class="dropdown-item"
            href="#"
          >
            <i class="fas fa-fw fa-edit " /> &nbsp; Action
          </a>
          <a
            class="dropdown-item"
            href="#"
          >
            <i class="fas fa-fw fa-headphones-alt " /> &nbsp; Another action
          </a>
          <div class="dropdown-divider" />
          <a
            class="dropdown-item"
            href="#"
          >
            <i class="fas fa-fw fa-star " /> &nbsp; Something else here
          </a>
        </div>
      </li>
      <li
        v-if="$auth.check()"
        class="nav-item dropdown no-arrow madgui-right-navbar-user"
      >
        <a
          id="userDropdown"
          class="nav-link dropdown-toggle user-dropdown-link"
          href="#"
          role="button"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
        >
          <img
            alt="Avatar"
            src="@/assets/theme/img/user.png"
          >
          MadGUI
        </a>
        <div
          class="dropdown-menu dropdown-menu-right"
          aria-labelledby="userDropdown"
        >
          <!-- <router-link class="dropdown-item" to="/account"><i class="fas fa-fw fa-user-circle"></i> &nbsp; My Account</router-link> -->
          <!-- <router-link class="dropdown-item" to="/subscriptions"><i class="fas fa-fw fa-video"></i> &nbsp; Subscriptions</router-link> -->
          <!-- <router-link class="dropdown-item" to="/settings"><i class="fas fa-fw fa-cog"></i> &nbsp; Settings</router-link> -->
          <!-- <div clSass="dropdown-divider"></div> -->
          <a
            class="dropdown-item"
            href="#"
            data-toggle="modal"
            data-target="#logoutModal"
          >
            <i class="fas fa-fw fa-sign-out-alt" /> &nbsp; Logout
          </a>

          <!-- <div class="dropdown-left-onhover">
            <a data-target="#admin-db-actions">
              #DB
            </a>
            <ul
              id="admin-db-actions"
              class="dropdown-menu"
            >
              <li>
                <a @click="run('backupDbs')">
                  Backup Databases
                </a>
              </li>
              <li>
                <a @click="run('createSnapshot')">
                  Create Snapshot
                </a>
              </li>
              <li>
                <a @click="run('loadSnapshot')">
                  Load Snapshot
                </a>
              </li>
              <li>
                <a @click="run('resetTest')">
                  Reset Test
                </a>
              </li>
            </ul>
          </div> -->
        </div>
      </li>
      <li
        v-else
        class="nav-item mx-1"
      >
        <RouterLink
          class="nav-link"
          to="/login"
        >
          <i class="fas fa-sign-in-alt fa-fw" />
          Login
        </RouterLink>
      </li>
    </ul>
  </nav>
</template>

<script>
/* eslint-env jquery */
import { sync } from 'vuex-pathify';

export default {
  components: {
    Brand: () => import('@/components/layout/Brand'),
    VideoTags: () => import('@/components/video/VideoTags'),
    // VideoSearch: () => import('@/components/video/VideoSearch'),
  },

  computed: {
    ...sync([
      'site.options', //
    ]),
  },

  methods: {
    toggleSidebar() {
      $('body').toggleClass('sidebar-toggled');
      $('.sidebar').toggleClass('toggled');
    },

    run() {
      console.log('run');
    },
  },
};
</script>
